import { SET_ESTIMATION_DATA, SET_ESTIMATION_LOADING,SET_ESTIMATION_SUMMARY } from "../types"

export const setEstimationData = (data) => ({
    type: SET_ESTIMATION_DATA,
    payload: data
})
export const setEstimationSummary = (data) => ({
    type: SET_ESTIMATION_SUMMARY,
    payload: data
})

export const setEstimationLoading = (loading) => ({
    type: SET_ESTIMATION_LOADING,
    payload: loading,
})
